import { defineMessages } from 'react-intl';
import globalIntl from 'globalIntl'; // eslint-disable-line import/no-unresolved

const m = defineMessages({
  duplicate: {
    id: 'duplicate',
    defaultMessage: 'Duplicate',
  },
  makeDynamicPage: {
    id: 'makeDynamicPage',
    defaultMessage: 'Make dynamic page',
  },
  makeStaticPage: {
    id: 'makeStaticPage',
    defaultMessage: 'Make static page',
  },
  staticPage: {
    id: 'staticPage',
    defaultMessage:
      'The page is static, that is when rendering, the Corezoid process is not called',
  },
});

export default { ...globalIntl, ...m };
